var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-layout',{attrs:{"fiftyPercentWidth":true}},[_c('signup-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }